export default "__VITE_ASSET__BnuG$BQK__";